export const getHoverColor = (x) => getPastelColor(x, 'd9');
export const getPastelColor = (x, alphaHex) => /^#.{6}$/.test(x?.toString() ?? '') ? `${x}${alphaHex ?? '2a'}` : x;
//# sourceMappingURL=color.js.map